export const abbreviatedStringFormat = (value: string) => {
  return value ? value.replaceAll('BINANCE', 'BIN').replaceAll('SPOT', 'S').replaceAll('FUTURES', 'F') : value;
};
